import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import {
  DocumentActionCategoryType,
  DocumentActionType,
  DownloadDocumentRequestType,
  FileDocumentResponse,
} from '@finxone-platform/shared/sys-config-types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private baseUrl = '';

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.configService.getApi('account_service').subscribe((response) => {
      this.baseUrl = response;
    });
  }

  public deleteDocument(type: DocumentActionType, entityId: string, fileId: string): Observable<boolean> {
    return this.http.delete<boolean>(`${this.baseUrl}/documents/${type}/${entityId}/document/${fileId}`);
  }

  /**
   * The delete account-service actually declares: `DELETE /documents/:type/:entityId` with the
   * file id and category in the BODY (`DocumentInfoDto`). `deleteDocument` above posts to a
   * four-segment path that matches no route on that controller; it is left alone here because
   * its callers are not this one's business, but nothing new should use it.
   */
  public deleteStoredDocument(
    type: DocumentActionType,
    entityId: string,
    body: { fileId: string; category?: DocumentActionCategoryType },
  ): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(`${this.baseUrl}/documents/${type}/${entityId}`, {
      body,
    });
  }

  public uploadDocument(payload: FormData) {
    return this.http.post<FileDocumentResponse[]>(`${this.baseUrl}/documents`, payload);
  }

  public getDocumentFileId(type: DocumentActionType, entityId: string) {
    return this.http.get<FileDocumentResponse[]>(`${this.baseUrl}/documents/${type}/${entityId}`);
  }

  public getDocumentFiles(type: DocumentActionType, entityId: string, category: DocumentActionCategoryType) {
    return this.http.get<FileDocumentResponse[]>(
      `${this.baseUrl}/documents/${type}/${entityId}?category=${category}`,
    );
  }

  public getFile(type: DocumentActionType, entityId: string) {
    return this.http.get<{ path: string }[]>(`${this.baseUrl}/documents/${type}/${entityId}/view`);
  }

  public replaceDocument(payload: FormData, type: DocumentActionType, entityId: string) {
    return this.http.put<FileDocumentResponse[]>(`${this.baseUrl}/documents/${type}/${entityId}`, payload);
  }

  public downloadDocument(type: DocumentActionType, entityId: string, payload: DownloadDocumentRequestType) {
    return this.http.post(`${this.baseUrl}/documents/${type}/${entityId}/download`, payload, {
      observe: 'response',
      responseType: 'blob',
    }) as Observable<HttpResponse<Blob>>;
  }
}
